import sdl from '@jds/react-generated-sdl/JDSAvatarV2Default';
import type { JDSAvatarV2DefaultProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSAvatarV2DefaultProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'medium',
    kind = 'icon',
    disabled = false,
    ariaLabel = 'Avatar',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { size, kind, disabled, ariaLabel, ...rest },
    'JDSAvatarV2Default',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const AvatarV2Default = withLogic(
  Component
) as React.FC<JDSAvatarV2DefaultProps> & { slotName?: string };

AvatarV2Default.displayName = 'AvatarV2Default';
AvatarV2Default.slotName = 'jds_avatar_v_2_default';

export { AvatarV2Default, type JDSAvatarV2DefaultProps };
